<template>
  <div id="myorder">
    <p
      class="title "
      style="height: 40px;font-size: 24px;font-family: MicrosoftYaHei;color: #262626;line-height: 40px;"
    >
      我的订单
    </p>
    <ul class="order-nav">
      <li
        @click="changeorder(0)"
        :class="status == 0 ? 'theme-col' : ''"
        style="border-color: #ccc!important"
      >
        全部订单
      </li>
      <li
        @click="changeorder(1)"
        :class="status == 1 ? 'theme-col' : ''"
        style="border-color: #ccc!important"
      >
        待支付
      </li>
      <li
        @click="changeorder(2)"
        :class="status == 2 ? 'theme-col' : ''"
        style="border-color: #ccc!important"
      >
        待发货
      </li>
      <li
        @click="changeorder(3)"
        :class="status == 3 ? 'theme-col' : ''"
        style="border-color: #ccc!important"
      >
        已发货
      </li>
      <li
        @click="changeorder(4)"
        :class="status == 4 ? 'theme-col' : ''"
        style="border-color: #ccc!important"
      >
        已取消
      </li>
    </ul>
    <div class="order-list" v-loading="loading">
      <div
        style="width:100%;height:1px;background:#f5f5f5;"
        v-if="orderlist == ''"
      ></div>
      <ul class="order-th order-row" v-if="orderlist != ''">
        <li>商品信息</li>
        <li>单价</li>
        <li>数量</li>
        <li>合计</li>
        <li>订单状态</li>
        <li>操作</li>
      </ul>
      <div class="empty" v-if="!loading && orderlist == ''">
        <img src="/static/img/noorder.png" alt />
        <p>还没有相关订单</p>
      </div>
      <div class="orders" v-if="orderlist != ''">
        <table
          class="order-table"
          v-for="(item, index) in orderlist"
          :key="item.id_order"
        >
          <tr>
            <td colspan="6" class="order-info">
              <span style="padding-left: 30px;"
                >订单号：{{ item.ordersn }}</span
              >
              <span class="order-time">下单时间：{{ item.order_time }}</span>
            </td>
          </tr>
          <tr>
            <td colspan="3">
              <div class="product-table">
                <table v-for="(product, i) in item.products" :key="i">
                  <tr>
                    <td class="product-img">
                      <router-link
                        tag="a"
                        target="_blank"
                        :to="{ name: 'Detail', params: { id: product.m_id } }"
                        style="width:80px;height:80px;"
                      >
                        <img
                          style="width:80px;height:80px;margin-left: 25px;"
                          v-lazy="product.img"
                          onerror="src='/static/imgout1.png'"
                          alt
                          lazy
                        />
                      </router-link>
                    </td>
                    <td>
                      <router-link
                        tag="a"
                        target="_blank"
                        :to="{ name: 'Detail', params: { id: product.m_id } }"
                      >
                        <div class="product-name" :title="product.name">
                          <span class="jd" v-show="product.type == 1"
                            >优选</span
                          >
                          <span class="yx" v-show="product.type == 6"
                            >严选</span
                          >
                          <span class="new" v-show="product.type == 2"
                            >直充</span
                          >
                          <span class="rob" v-show="product.type == 3"
                            >卡券</span
                          >
                          {{ product.name }}
                        </div>
                      </router-link>
                    </td>
                    <td>
                      <div class="product-point">
                        <span v-if="Number(product.points)">{{ product.points }}{{ $store.state.name }}</span>
                        <span v-if="product.cash">
                          <span v-if="Number(product.points)">+</span>{{ product.cash }}元
                        </span>
                      </div>
                    </td>
                    <td>
                      <div class="product-nums">{{ product.nums }}</div>
                    </td>
                  </tr>
                </table>
              </div>
            </td>
            <td>
              <div class="totalpoints">
                <span class="theme-col">
                  <span v-if="item.totalpoints">{{ item.totalpoints }}{{ $store.state.name }}</span>
                  <span v-if="item.total_cash">
                    <span v-if="item.totalpoints">+</span>{{ item.total_cash }}元
                  </span>
                </span>
              </div>
            </td>
            <td v-if="status == 1">
              <div class="pay_status">待支付</div>
            </td>
            <td v-else-if="status == 2">
              <div class="pay_status">待发货</div>
            </td>
            <td v-else-if="status == 3">
              <div v-if="item.order.refund_status" class="pay_status">
                {{ item.order.refund_status == 1 ? '部分退款' : '全部退款' }}
              </div>
              <div class="pay_status" v-else>已发货</div>
            </td>
            <td v-else>
              <div class="pay_status" v-if="item.status == -1">已取消</div>
              <div class="pay_status" v-if="item.status == 0">待付款</div>
              <div class="pay_status" v-if="item.status == 1">待发货</div>
              <div class="pay_status" v-if="item.status == 2">
                <div v-if="item.order.refund_status" class="pay_status">
                  {{ item.order.refund_status == 1 ? '部分退款' : '全部退款' }}
                </div>
                <div class="pay_status" v-else>部分发货</div>
              </div>
              <div class="pay_status" v-if="item.status == 3">
                <div v-if="item.order.refund_status" class="pay_status">
                  {{ item.order.refund_status == 1 ? '部分退款' : '全部退款' }}
                </div>
                <div class="pay_status" v-else>已发货</div>
              </div>
              <div class="pay_status" v-if="item.status == 4">交易关闭</div>
            </td>
            <td>
              <div class="operate">
                <div>
                  <!--    -->
                  <span
                    class="theme-bg nopay"
                    v-if="item.status == 0"
                    @click="payfor(item.id_order)"
                    >去支付</span
                  >
                </div>
                <div>
                  <span>
                    <router-link
                      :to="{
                        name: 'Orderdetail',
                        params: { id: item.id_order, status: status }
                      }"
                      >订单详情</router-link
                    >
                  </span>
                </div>
                <div>
                  <span
                    style=" height: 19px;font-size: 14px;font-family: MicrosoftYaHei;color: #4478D6;line-height: 19px;"
                    @click="cancel(item.id_order, item.is_cancel)"
                    v-if="item.is_cancel > 0"
                    >取消订单</span
                  >
                </div>
                <div>
                  <span
                    style=" height: 19px;font-size: 14px;font-family: MicrosoftYaHei;color: #4478D6;line-height: 19px;"
                    v-if="item.status == -1"
                    @click="deleteorder(item.id_order)"
                    >删除订单</span
                  >
                </div>
              </div>
            </td>
          </tr>
        </table>

        <div style="margin: 15px 0 25px 0;text-align: center" class="block">
          <!--   v-if="orderlist.length>count" -->
          <el-pagination
            layout="prev,pager, next"
            :total="total * count"
            :page-size="count"
            :current-page.sync="page"
          ></el-pagination>
        </div>
      </div>
    </div>

    <el-dialog
      title="提示"
      :visible.sync="dialogVisible"
      :before-close="handleClose"
    >
      <el-row
        style="width:562px;    display: flex;
    margin: 0 auto; align-items: center;padding-bottom:80px"
      >
        <el-col style="padding-right:57px;">
          <canvas
            id="paycanvas"
            width="182px"
            style="width:182px;border: 1px solid #C7C7C7;"
          ></canvas>
          <br />
          <div
            style="width: 182px;height: 48px;background: rgb(226, 49, 48);display: flex;justify-content: space-between;color: #fff; padding: 10px 15px;box-sizing: border-box;align-items: center;"
          >
            <img style="width:24px;height:24px;" src="/static/img/sm.png" />
            <p style="color:#fff;font-size: 13px;line-height:17px;width:104px">
              请使用微信扫一扫 扫描二维码支付
            </p>
          </div>
        </el-col>
        <el-col>
          <img style="width:320px;" src="/static/img/phone.png" alt />
        </el-col>
      </el-row>
    </el-dialog>
  </div>
</template>
<script>
import pay from "@/mixins/pay.js";
export default {
  name: "",
  mixins: [pay],
  data() {
    return {
      loading: true,
      total: "",
      count: 5,
      status: 0, //订单状态 0:全部 1:待支付 2:待发货 3:已发货 4:已取消
      page: 1, //页数
      orderlist: [] //列表
    };
  },
  watch: {
    page(oldV, newV) {
      this.getDota();
    }
  },
  methods: {
    getDota() {
      this.$api.get(
        "order/orders/plist",
        {
          id_example: this.$store.state.id_example,
          token_user: this.$store.state.user_id,
          status: this.status,
          page: this.page
        },
        res => {
          if (res.data.code == 100) {
            this.loading = false;
            this.orderlist = res.data.data.list;
            this.total = res.data.data.totalPage;
          } else if (res.data.code == -101) {
            this.$alert("登录超时请重新登录", "提示", {
              confirmButtonText: "确定",
              callback: action => {}
            });
            this.$router.push({ name: "Login", params: { type: 1 } });
          }
        },
        err => {
          this.$router.push({ name: "Overtime" });
        }
      );
    },
    changeorder(type) {
      this.page = 1;
      this.status = type;
      this.getDota();
    },
    deleteorder(id) {
      this.$confirm("确定删除该订单？", "提示", {
        confirmButtonText: "确定",
        cancelButtonText: "取消",
        type: "warning"
      })
        .then(() => {
          this.$api.post(
            "order/orders/delete",
            {
              id_example: this.$store.state.id_example,
              token_user: this.$store.state.user_id,
              id_order: id
            },
            res => {
              if (res.data.code == 100) {
                this.$message({
                  message: "删除成功",
                  duration: 1500,
                  center: true
                });
                this.getDota();
              }
            }
          );
        })
        .catch(() => {});
    },
    //取消订单
    cancel(id, type) {
      this.$confirm("确定取消该订单？", "提示", {
        confirmButtonText: "确定",
        cancelButtonText: "取消",
        type: "warning"
      })
        .then(() => {
          this.$api.post(
            "order/orders/cancel",
            {
              id_example: this.$store.state.id_example,
              token_user: this.$store.state.user_id,
              id_order: id,
              type: type
            },
            res => {
              if (res.data.code == 100) {
                this.$message({
                  message: "取消成功",
                  duration: 1500,
                  center: true
                });
                this.getDota();
              }
            }
          );
        })
        .catch(() => {});
    },
    //去支付
    payfor(order) {
      this.$confirm("确定支付该订单？", "提示", {
        confirmButtonText: "确定",
        cancelButtonText: "取消",
        type: "warning"
      })
        .then(() => {
          this.wxPay(order);
        })
        .catch(() => {});
    }
  },
  mounted() {
    this.getDota();
  }
};
</script>
<style lang="less" scoped>
.number {
  background: none;
  width: 35px !important;
  height: 35px !important;
  background: #ffffff !important;
  border-radius: 3px !important;
  border: 1px solid #e7e7e7 !important;
}
/deep/ .el-pager li {
  width: 35px !important;
  height: 35px !important;
  background: #ffffff !important;
  border-radius: 3px !important;
  border: 1px solid #e7e7e7 !important;
  margin: 0px 2.5px !important;
}
/deep/ .el-pagination .btn-next,
/deep/.el-pagination .btn-prev {
  width: 35px !important;
  height: 35px !important;
  background: #ffffff !important;
  border-radius: 3px !important;
  border: 1px solid #e7e7e7 !important;
  margin: 0px 2.5px !important;
}
/deep/ .el-pager li.active {
  color: #e53940 !important;
  background: rgba(229, 57, 64, 0.1) !important;
  border: 1px solid #e53940 !important;
}

.theme-col {
  height: 20px;
  font-size: 15px;
  font-family: MicrosoftYaHei;
  // font-weight: bold;
  color: #e23130;
  line-height: 20px;
}
#myorder {
  min-height: 570px;
  box-shadow: 0px 9px 13px 0px rgba(190, 190, 190, 0.2);
}
.empty {
  overflow: hidden;
  height: 240px;
  margin-top: 60px;
  p {
    color: #7a7a7a;
  }
  img {
    width: 252px;
    // height: 146px;
    margin-bottom: 10px;
  }
}
.col-86 {
  color: #868686;
}
.nopay {
  padding: 3px 10px;
  color: #fff;
  width: 60px;
  height: 22px;
  background: #e23130;
  border-radius: 4px;
  border: 1px solid #e23130;
  box-sizing: border-box;
  font-size: 12px;
}
.y-middle {
  position: absolute;
  top: 50%;
  transform: translateY(-50%);
}
.x-middle {
  position: absolute;
  left: 50%;
  transform: translateX(-50%);
}
.xy-middle {
  position: absolute;
  top: 50%;
  left: 50%;
  transform: translate(-50%, -50%);
}
#myorder {
  width: 985px;
  display: inline-block;
  background: #fff;
  padding: 10px 30px;
  box-sizing: border-box;
  .order-nav {
    margin-top: 15px;
    height: 18px;
    li {
      display: inline-block;
      padding: 0px 20px;
      // border-left: 1px solid #cccccc;
      font-size: 15px;
    }
    li:first-child {
      padding-left: 0px;
      border-left: none;
    }
  }
  .order-list {
    margin-top: 15px;
    min-height: 472px;
    .order-th {
      background: #f3f3f3;
      height: 44px;
      line-height: 44px;
      //border: 1px solid #e3e3e3;
      border-bottom: none;
    }
    .order-row {
      padding-left: 30px;

      border: 1px solid #dbdbdb;
      border-bottom: none;

      li {
        display: inline-block;
        text-align: center;
      }
      li:nth-child(1) {
        width: 354px;
        text-align: left;
      }
      li:nth-child(2) {
        width: 100px;
      }
      li:nth-child(3) {
        width: 100px;
      }
      li:nth-child(4) {
        width: 100px;
      }
      li:nth-child(5) {
        width: 100px;
      }
      li:nth-child(6) {
        width: 100px;
      }
    }

    .orders {
      table {
        table-layout: inherit;
      }
      td {
        vertical-align: middle;
        color: #353535;
      }
      .order-table {
        width: 100%;
        margin-top: 20px;
        border: 1px solid #e3e3e3;
        text-align: center;
        & > tr > td {
          padding-top: 25px;
          padding-bottom: 25px;
        }
        & > tr > td:first-child {
          text-align: left;
        }
        & > tr:last-child {
          td {
          }
        }
        .order-info {
          padding: 10px 0px;
          font-size: 12px;
          font-family: MicrosoftYaHei;
          color: #262626;
          line-height: 21px;
          position: relative;
          &::after {
            content: "";
            position: absolute;
            width: 867px;
            height: 1px;
            left: 25px;
            bottom: 0;
            border-bottom: dashed 1px #dbdbdb;
          }
          .order-time {
            margin-left: 24px;
          }
        }

        .product-table {
          width: 510px;
          table {
            margin-top: 20px;
          }
          table:first-child {
            margin-top: 0;
          }
          .product-img {
            & > img {
              width: 90px;
              height: 90px;
            }
          }
          .product-name {
            padding-left: 24px;
            font-size: 13px;
            width: 254px;
          }
          .product-point {
            width: 100px;
            text-align: center;
          }
          .product-nums {
            width: 100px;
            text-align: center;
          }
        }
        .totalpoints {
          width: 100px;
        }
        .pay_status {
          width: 90px;
        }
        .operate {
          width: 90px;
          line-height: 24px;
          a {
            height: 19px;
            font-size: 14px;
            font-family: MicrosoftYaHei;
            color: #4478d6;
            line-height: 19px;
          }
          span {
          }
        }
      }
      .order-table:first-child {
        margin-top: 0px;
      }
    }
  }
}
</style>



// WEBPACK FOOTER //
// src/pages/user/cont/myorder.vue